import {

  FETCH_FORGET_REQUEST,
  FETCH_FORGET_SUCCESS,
  FETCH_FORGET_FAIL,
  FETCH_CONFIRMATIONCODE_REQUEST ,
  FETCH_CONFIRMATIONCODE_SUCCESS,
  FETCH_CONFIRMATIONCODE_FAIL,
  FETCH_RESETPASSWORD_REQUEST ,
  FETCH_RESETPASSWORD_SUCCESS ,
  FETCH_RESETPASSWORD_FAIL ,
  BACK
 } from "./type";

 import axios from 'axios';
 import { API_ENDPOINT, MyTicket_PATH,MyTicket_RULES, MyTicket_USER, MyTicket_TOKEN, MyTicket_TYPE, MyTicket_LANGUAGE,
  MyTicket_USER_Cinema, MyTicket_TOKEN_Cinema, MyTicket_TYPE_Cinema, MyTicket_LANGUAGE_Cinema,
  MyTicket_USER_Event, MyTicket_TOKEN_Event, MyTicket_TYPE_Event, MyTicket_LANGUAGE_Event
} from '../../AppConfig';
 import {showSnack} from 'react-redux-snackbar';
 import {hideLoading,showLoading} from 'react-redux-loading-bar';
 import String from "../../Assets/Localization/local"
 import cookie from 'react-cookies';

 export function forgetPassword(data,Lang){
  String.setLanguage(Lang)
  return (dispatch)=>{
    dispatch({type:FETCH_FORGET_REQUEST});
    dispatch(showLoading());
  
    axios.post(`${API_ENDPOINT}/forgetPassword`,data,{
      headers:{
        "Content-Type": "application/json"
      }
    })
    .then(response=>{
        dispatch({ payload: data,type:FETCH_FORGET_SUCCESS})
        dispatch(hideLoading());
    })
    .catch(err=>{
      dispatch({type:FETCH_FORGET_FAIL})
      if (!err.response) {
        dispatch(hideLoading());
        dispatch(showSnack('myUniqueId', {
            label:String.networkError,
            timeout: 7000,
            button: { label: String.forgetPasswordKey}
        }));
    
      }
    else if (err.response.status === 404 ||err.response.status === 422) {
      dispatch(hideLoading());
      dispatch(showSnack('myUniqueId', {
          label:String.emailError,
          timeout: 7000,
          button: { label:String.forgetPasswordKey}
          })); 
       } 
       else if (err.response.status === 403 ) {
        dispatch(hideLoading());
        dispatch(showSnack('myUniqueId', {
            label:String.userError,
            timeout: 7000,
            button: { label:String.forgetPasswordKey}
            }));
      }
       else if (err.response.status === 401) {
        dispatch(hideLoading());
       }
    
  });
 
}
}



export function confirmCode (data,Lang){
      String.setLanguage(Lang)
    return (dispatch)=>{
      dispatch({type:FETCH_CONFIRMATIONCODE_REQUEST});
      dispatch(showLoading());
      if(data.code&&data.email&&data.type){
      axios.put(`${API_ENDPOINT}/confirmationCode`,JSON.stringify(data),
      {
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': Lang
        }
      }
      )
      .then(response=>{
        dispatch({
          payload:response.data,
          type:FETCH_CONFIRMATIONCODE_SUCCESS})
        dispatch(hideLoading());
      })
      .catch(err=>{
        dispatch({type:FETCH_CONFIRMATIONCODE_FAIL});
        if (!err.response) {
          dispatch(hideLoading());
          dispatch(showSnack('myUniqueId', {
              label: String.networkError,
              timeout: 7000,
              button: { label:String.forgetPasswordKey}
          }));
      
      }
      else{
        dispatch(hideLoading());
        dispatch(showSnack('myUniqueId', {
            label: String.codeError,
            timeout: 7000,
            button: { label:String.forgetPasswordKey}
            })); 
      }
      })
    }}
}

export function newpassword (data,Lang){
  String.setLanguage(Lang)
  return(dispatch)=>{
    dispatch({type:FETCH_RESETPASSWORD_REQUEST});
    if(data.email&& data.type&&data.newPassword){

    axios.put(`${API_ENDPOINT}/confirmationchange`,data,
    {
      headers: {
          'Content-Type': 'application/json',
          'Accept-Language': Lang
      }
     }
    ).then(response=>{
      // let userObject=[
      //   {key:MyTicket_USER,value:response.data.user},
      //   {key:MyTicket_TOKEN,value:response.data.token},
      //   {key:MyTicket_TYPE,value:response.data.user.type},
      //   {key:MyTicket_RULES,value:response.data.user.rules},
      //   {key:MyTicket_LANGUAGE,value:response.data.user.language},
      // ]


      let userObject = []
      if(response.data.user.type==="ADMIN"){
         userObject = [
          { key: MyTicket_USER, value: response.data.user },
          { key: MyTicket_TOKEN, value: response.data.token },
          { key: MyTicket_TYPE, value: response.data.user.type },
          // { key: MyTicket_RULES, value: response.data.user.rules },
          {key:MyTicket_RULES,value:response.data.user.rules},
          { key: MyTicket_LANGUAGE, value: response.data.user.language },
        ]
        sessionStorage.setItem("TicketUser", "ADMIN")
      }else if(response.data.user.categoryType==="CINEMA"){
        userObject = [
          { key: MyTicket_USER_Cinema, value: response.data.user },
          { key: MyTicket_TOKEN_Cinema, value: response.data.token },
          { key: MyTicket_TYPE_Cinema, value: response.data.user.type },
          // { key: MyTicket_RULES, value: response.data.user.rules },
          { key: MyTicket_LANGUAGE_Cinema, value: response.data.user.language },
        ]
        sessionStorage.setItem("TicketUser", "CINEMA")
      }else{
        userObject = [
          { key: MyTicket_USER_Event, value: response.data.user },
          { key: MyTicket_TOKEN_Event, value: response.data.token },
          { key: MyTicket_TYPE_Event, value: response.data.user.type },
          // { key: MyTicket_RULES, value: response.data.user.rules },
          { key: MyTicket_LANGUAGE_Event, value: response.data.user.language },
        ]
        sessionStorage.setItem("TicketUser", "EVENT")
      }

      saveToCookies(userObject)
      //dispatch({payload:response.data ,type:FETCH_LOGIN_SUCCESS  });
      dispatch({type:FETCH_RESETPASSWORD_SUCCESS})
      dispatch(hideLoading());
    })
    .catch(err=>{
      dispatch({type:FETCH_RESETPASSWORD_FAIL});
      if (!err.response) {
        dispatch(hideLoading());
        dispatch(showSnack('myUniqueId', {
            label:String.networkError,
            timeout: 7000,
            button: { label:String.forgetPasswordKey}
        }));
    
    }
     
    })
  }
}
}
export function back(){
  return(dispatch)=>{
    dispatch({type:BACK})
  }
}
export function saveToCookies(object) {
  for(let i=0;i<object.length;i++){
    cookie.save(object[i].key,  JSON.stringify(object[i].value),{path:MyTicket_PATH});
  }
}